<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>社媒链接管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="tips">
        勿动；SaaS 后台 社媒链接管理 维护的 各社交媒体的键值配置。前台/业务方按社媒类型和key取值，未命中时回退 default。
      </div>
      <div class="toolbar">
        <el-button type="primary" icon="el-icon-plus" @click="openCreateDialog">添加</el-button>
        <el-select v-model="query.mediaType" placeholder="请选择社媒类型" clearable @change="handleSearch">
          <el-option
            v-for="item in mediaTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <el-table :data="list" border size="small">
        <el-table-column prop="mediaType" label="社媒类型" min-width="140">
          <template slot-scope="scope">
            <span>{{ getMediaTypeLabel(scope.row.mediaType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="key" label="标签" min-width="140" />
        <el-table-column prop="value" label="url" min-width="320" show-overflow-tooltip />
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="pagination.total"
        @pageChanged="handlePageChanged"
      />
    </el-card>

    <el-dialog
      :title="dialogMode === 'create' ? '添加社媒链接' : '编辑社媒链接'"
      :visible.sync="dialogVisible"
      width="520px"
      @close="resetDialog"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="社媒类型" prop="mediaType">
          <el-select v-model="form.mediaType" placeholder="请选择社媒类型" style="width: 100%">
            <el-option
              v-for="item in mediaTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标签" prop="key">
          <el-input v-model.trim="form.key" placeholder="请输入标签，如 default / zh / en" />
        </el-form-item>
        <el-form-item label="url" prop="value">
          <el-input v-model.trim="form.value" placeholder="请输入链接" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from 'components/pagination';
import api from './api';

const createDefaultForm = () => ({
  mediaType: '',
  key: '',
  value: '',
  originalMediaType: '',
  originalKey: ''
});

export default {
  name: 'MediaSetting',
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      dialogMode: 'create',
      list: [],
      query: {
        mediaType: ''
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      form: createDefaultForm(),
      mediaTypeOptions: [
        { label: 'Telegram', value: 'telegram' },
        { label: 'Twitter', value: 'twitter' },
        { label: 'Email', value: 'email' },
        { label: 'Medium', value: 'medium' },
        { label: 'Discord', value: 'discord' }
      ],
      rules: {
        mediaType: [{ required: true, message: '请选择社媒类型', trigger: 'change' }],
        key: [{ required: true, message: '请输入标签', trigger: 'blur' }],
        value: [{ required: true, message: '请输入url', trigger: 'blur' }]
      }
    };
  },
  methods: {
    getMediaTypeLabel(mediaType) {
      const match = this.mediaTypeOptions.find(item => item.value === mediaType);
      return match ? match.label : mediaType;
    },
    fetchList() {
      this.loading = true;
      api.getList({
        page: this.pagination.page,
        size: this.pagination.size,
        mediaType: this.query.mediaType || undefined
      }).then(res => {
        const data = res && res.data ? res.data : {};
        this.list = data.list || [];
        this.pagination.total = data.totalCount || 0;
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSearch() {
      this.pagination.page = 1;
      this.fetchList();
    },
    handlePageChanged(pagination) {
      this.pagination.page = pagination.page;
      this.pagination.size = pagination.size;
      this.fetchList();
    },
    openCreateDialog() {
      this.dialogMode = 'create';
      this.form = createDefaultForm();
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.dialogMode = 'edit';
      this.form = {
        mediaType: row.mediaType || '',
        key: row.key || '',
        value: row.value || '',
        originalMediaType: row.mediaType || '',
        originalKey: row.key || ''
      };
      this.dialogVisible = true;
    },
    resetDialog() {
      this.form = createDefaultForm();
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        const request = this.dialogMode === 'create'
          ? api.addItem({
            mediaType: this.form.mediaType,
            key: this.form.key,
            value: this.form.value
          })
          : api.updateItem({ ...this.form });
        request.then(() => {
          this.$message.success(this.dialogMode === 'create' ? '添加成功' : '修改成功');
          this.dialogVisible = false;
          this.fetchList();
        }).finally(() => {
          this.submitting = false;
        });
      });
    },
    handleDelete(row) {
      this.$confirm('确认删除该配置吗？', '提示', { type: 'warning' }).then(() => {
        api.deleteItem({
          mediaType: row.mediaType,
          key: row.key
        }).then(() => {
          this.$message.success('删除成功');
          if (this.list.length === 1 && this.pagination.page > 1) {
            this.pagination.page -= 1;
          }
          this.fetchList();
        });
      });
    }
  },
  mounted() {
    this.fetchList();
  }
};
</script>

<style lang="less" scoped>
.tips {
  margin-bottom: 20px;
  color: #606266;
  line-height: 22px;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.toolbar .el-select {
  width: 220px;
}

.danger-text {
  color: #f56c6c;
}
</style>
